export default {
	textBtn: {
        btnSearch: 	'Buscar',
        btnSend: 	'Enviar',
        btnUpdate: 	'Actualizar',
        btnDetail: 	'Detalle',
        btnSwitch: 	'Cambiar',
    },
	navbarMain: {
        search: 	'Buscar',
        filter: 	'Filtro',
        delete: 	'Borrar',
        password: 	'Cambio de contraseña',
        goOut: 		'Salir',
        help: 		'Ayuda',
        textSelectSwitchTenants:  'Selecciona un tenant',
        errorOnChangeTenant: 'Error al intentar cambiar el tenant',
    },
    navbarInternal: {
        processes: 	        'Procesos',
        processesManage:    'Administrar procesos',
        radar: 		        'Radar',
        reports: 	        'Reportes',
        search:             'Buscador',
        updates: 	        'Actualizaciones',
        customers:          'Clientes',
        users:              'Usuarios',
        regulatoryAffairs:  'Asuntos normativos',
        rules:              'Normas',
        diagnosis:          'Diagnóstico',
        topicsSubtopics:    'Temas/SubTemas',
        reportStructuring:  'Reportes estructurador',
        monthlyStatistics:  'Estadística mensual',
    },
    gridHeaderText: {
        expiration: 	'VENCIMIENTO',
        manager: 'ENCARGADO',
        textManager: 'Encargado',
        textErrorManager:       '*Selecciona un encargado',
        periodicity: 	'PERIODICIDAD',
        exercise: 		'ACTIVIDAD',
        state: 			'ESTADO',
        evidence: 		'EVIDENCIA',
        observations: 	'OBSERVACIONES',
        obligation: 	'DEBERES',
        compliance: 	'CUMPLIMIENTO',
        process: 		'PROCESO',
        affair: 		'ASUNTO',
        description: 	'DESCRIPCIÓN',
        date: 			'FECHA',
        support: 		'SOPORTE',
        businessName:   'RAZÓN SOCIAL',
        email:          'E-MAIL',
        phone:          'TELÉFONO',
        city:           'CIUDAD',
        direction:      'DIRECCIÓN',
        user:           'USUARIO',
        profile:        'PERFIL',
        name:           'NOMBRE',
        identification: 'CÈDULA',
        actions:        'ADJUNTOS',
        keywords:       'PALABRAS CLAVES',
        topic:          'TEMA',
        subtopic:       'SUBTEMA',
        prefix:         'PREFIJO',
        article:        'ARTICULO',
        standard_type:  'TIPO NORMA',
        number:         'NÚMERO',
        year:           'AÑO',
        denomination:   'DENOMINACIÓN',
        content:        'CONTENIDO',
        tenant:         'TENANT',
        publicPrivate:  'PUBLICO / PRIVADO'
    },
    textLogin: {
        textEmail: 		'Correo Electrónico',
        textPassword: 	'Contraseña',
    },
    textDashboard: {
        statisticsDataVen: 	'Vencidos',
        statisticsData30: 	'30 días',
        statisticsData60: 	'60 días',
        statisticsData90: 	'90 días',
        titleExecuted: 	    'Ejecutados',
        titleCompliance: 	'Cumplimientos',
        titleCalendar: 		'Calendario',
        today:              'Hoy',
        noEvents:           'No hay eventos',
        all:                'Todos',
        radar:              'Radar',
        updates:            'Actualizaciones',
    },
    textProcesses: {
        textTitle: 						'Procesos',
        statisticsComplianceExpired: 	'Vencidos',
        statisticsFulfillmentsExpire: 	'Próximos a vencer',
        statisticsUpdates: 				'Actualizaciones',
        textTitleCompliance: 			'Cumplimientos',
        textTitleObligation: 			'Deberes',
        textTitleAffair: 				'Asuntos normativos',
        textTitleDescription: 			'Descripción',
        textTitleRules: 				'Normas',
        textTitleHistory: 				'Historial',
        textTitleState: 				'Estado',
        textTitleEvidence: 				'Evidencia',
        textTitleUpdate: 				'Actualizar',
        textClassification:             'Clasificación',
        textTitleExpired:               'Pendientes',
        textTitleExecuted:              'Ejecutados'
    },
    textReports: {
        textTitle: 				'Reportes',
        btnTextNewReport: 		'Nuevo reporte',
        btnTextExportExcel: 	'Exportar a excel',
        textFormUser: 			'Usuario',
        textFormObject: 		'Objetos',
        textFormProcess: 		'Proceso',
        textFormTypeAffair:     'Tipo de asunto',
        textFormStartdate: 		'Fecha inicio',
		textFormFinaldate: 		'Fecha final',
        textFormSelectReport: 	'Selecciona un reporte',
        textActiveFilters:      'Filtros activos: ',
        btnGenerating_report:      'Generando...'
    },
    textRadar: {
        textFormSelectProcess:  'Seleccione un proceso',
        textFormSelectSubject:  'Seleccione un asunto',
        textFormDescription:    'Descripción',
    },
    textCustomers: {
        textTitle:            'Clientes',
        textBtnNewCustomers:  'Nuevo cliente'
    },
    textUsers: {
        textTitle:                    'Usuarios',
        textBtnNewUser:               'Nuevo usuario',
        textBtnBulkLoad:              'Importar usuarios',
        textBtnBackStructuringUsers:  'Volver listado usuarios',
        textBtnProcessExcel:          'Procesar excel',
    },
    textSearch: {
        textTitle:                  'Buscador',
        norms: {
            tittle:                 'Título',
            norm:                   'Norma',
            denomination:           'Denominación',
            affairs:                'Asuntos',
            compliance:             'Cumplimientos',
            contentof:              'Contenido de la norma'
        },
        themes: {
            theme:                  'Tema',
            subtheme:               'Subtemas',
            affair:                 'Asuntos',
            complianceObligation:   'Cumplimiento/Deber',
            contentCompliance:      'Contenido cumplimiento/deber',
            norms:                  'Normas relacionadas',
        }
    },
    textTenants: {
        textFormSelect:             'Selecciona',
        textFormTypeBusinessName:   'Ingresa el nombre del cliente',
        textTittleState: 		    'Estado',
        textTittleBusinessName:     'Razón social',
        textTittleEmail: 		    'Correo electrónico',
        textTittlePhone: 		    'Teléfono',
        textTittleCelPhone: 	    'Celular',
        textTittleCountry:          'País',
        textTittleDepartament:      'Departamento',
        textTittleMunicipality:     'Municipio',
        textTittleAddress:          'Dirección',
        textTittleThemes:           'Temas',
        textTittleLicenses:         'Licencias',
        textTittleClient:           'Cliente',
        textTittleNotifications:    'Notificaciones',
        notification: {
            textInactive:           'Inactivo',
            textActive:             'Activo',
        },
        textTittleStructuringUser:  'Estructurador/es',
        textTittleLogo:             'Logo',
        textTittleBanner:           'Banner - Imagen en el dashboard',
        textErrorState:             '*Selecciona un estado',
        textErrorMunicipality:      '*Selecciona un municipio',
        textErrorBusinessName:      '*Ingresa de la razón social',
        textErrorEmail:             '*Ingresa un correo electrónico válido',
        textPagination:             'Paso {#} de {$}',
        textSaveButton:             'Guardar',
        textNextButton:             'Siguiente',
        textPreviousButton:         'Anterior',
        infoBrowser: {
            textTittle:             'Recuerda que',
            textRecomendationLogo1:     'Esta imagen será visible en los correos que se envíen en el proceso de firma de tus clientes.',
            textRecomendationLogo2:     'Formatos Permitidos: JPG, JPEG, PNG, BMP',
            textRecomendationLogo3:     'Dimensiones máximas (pixeles): 200x40',
            textRecomendationLogo4:     'Dimensiones mínimas (pixeles): 100x25',
            textRecomendationLogo5:     'Peso máximo de imagen: 1MB',
            textRecomendationBanner1:   'Esta imagen será visible en tu panel de control.',
            textRecomendationBanner2:   'Formatos permitidos: JPG, JPEG, PNG, BMP',
            textRecomendationBanner3:   'Dimensiones máximas (pixeles): 1200x300',
            textRecomendationBanner4:   'Dimensiones mínimas (pixeles): 1000x150',
            textRecomendationBanner5:   'Peso máximo de imagen: 1MB',
        },
        textCloneThemes:            'Clonar temas',
        textAssociatedTopics:       'Temas asociados',
    },
    textProcessesStructure:{
        textTitle:                  'Procesos',
        textName:                   'Nombre',
        textClassification:         'Clasificación',
        textResponsable:            'Responsable',
        textDescription:            'Descripción',
        textTeam:                   'Equipo',
        textQuery:                  'Consulta',
        textActions:                'Acciones',
        textFormSelect:             'Seleccione',
        textBulkLoad:               'Cargue Masivo',
        textSave:                   'Guardar',
        textCancel:                 'Cancelar',
        textErrorName:              '*Ingresa un nombre',
        textErrorClassification:    '*Ingresa una clasificación',
        textErrorResponsable:       '*Selecciona un Responsable',
        textBtnNewProcess:          'Nuevo proceso',
        textBtnLoadProcess:         'Cargar procesos',
    },
    textAffairAssociation:{
        textAssociationButton:      'Asociar un asunto',
        textAffairGrid:
        {
            affair:                 'Asunto',
            interest:               'Interés',
            theme:                  'Tema',
            subtheme:               'Subtema',
            delete:                 'Desasociar'
        },
    },
    textSessionExpired: {
        textHeader:             'Sesión expirada',
        textBody:               'Tu sesión ha expirado'
    },
    textUpdates: {
        textTitle:  'Actualizaciones',
    },
    textPassword: {
        textFormOldPassword:    'Ingresa tu contraseña actual',
        textFormNewPassword:    'Ingresa tu nueva contraseña',
        textFormRepeatPassword: 'Confirma tu contraseña',
    },
    textRegulatoryAffairs: {
        textTitle:              'Asuntos normativos',
        textLabelTitle:         'Título',
        textLabelPeriodicidad:  'Periodicidad',
        textFormAffair:         'Asunto',
        textFormTopic:          'Tema',
        textFormSubTopic:       'Subtema',
        textFormKeywords:       'Palabras clave',
        textBtnNew:             'Nuevo ',
        textErrorAffair:        '*Selecciona un asunto',
        textErrorTopic:         '*Selecciona un tema',
        textErrorSubtopic:      '*Selecciona un subtema',
        textTitleCompliance:    'Cumplimientos / Deberes',
    },
    textDiagnosis: {
        textTitle: 'Diagnóstico'
    },
    textDetailRule: {
        processes:  'Procesos',
        interest:   'Interés',
        loadRule:   'Cargar normas'
    },
    terms: {
        labels: {
          terms: 'Términos y condiciones',
        },
        messages: {
            loading: 'Cargando...'
        },
        buttons: {
            accept: 'Aceptar',
            cancel: 'Cancelar',
            processing: 'Procesando...'
        }
    },
    topicsSubTopics: {
        labels: {
            topics: 'Temas',
            subtopics: 'Subtemas',
            add: 'Agregar',
            update: 'Actualizar',
        },
        buttons: {
            add: 'Agregar',
            edit: 'Editar',
            save: 'Guardar',
            update: 'Actualizar',
            delete: 'Eliminar'
        },
        placeholder: {
            select_topic: 'Selecciona un tema',
            subtopic_name: 'Nombre del subtema',
            topic_name: 'Nombre del tema',
        },
        messages: {
            loading: 'Cargando...',
            processing: 'Procesando...',
            empty_topics: 'No hay temas actualmente.',
            empty_sub_topics: 'No hay subtemas para el tema seleccionado.'
        },
        validations: {
            topicId: '* El tema al que pertenecerá el subtema es requerido.',
            subtopic: '* El nombre del subtema es requerido.',
            topic: '* El nombre del tema es requerido'
        }
    }
}
